export default "assets/images/bg-404-08aeb4f8.png";